// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loder_loaderContainer__QdEkW","lodingText":"Loder_lodingText__+DPda","customLoader":"Loder_customLoader__YbY4H","s1":"Loder_s1__RigYY"};